import * as types from "./types";

export function fetchClientsStart() {
  return {
    type: types.FETCH_CLIENTS_START
  };
}

export function fetchClientsSuccess(clientsList) {
  return {
    type: types.FETCH_CLIENTS_SUCCESS,
    clientsList
  };
}

export function setRedirectFromRestoreToDashLoader(loader) {
  return {
    type: types.SET_REDIRECT_RESTORE_TO_DASHBOARD_LOADER,
    loader
  };
}

export function initiateBackup(clientUUID) {
  return {
    type: types.INITIATE_BACKUP,
    clientUUID
  };
}

export function backupSetCompleted(client) {
  return {
    type: types.BACKUP_SET_COMPLETED,
    client
  };
}

export function backupSetFailed(client) {
  return {
    type: types.BACKUP_SET_FAILED,
    client
  };
}

export function initiateStopBackup(clientUUID) {
  return {
    type: types.INITIATE_STOP_BACKUP,
    clientUUID
  };
}

export function stopBackup(client) {
  return {
    type: types.STOP_BACKUP,
    client
  };
}

export function updateBackupProgress(client) {
  return {
    type: types.UPDATE_BACKUP_PROGRESS,
    client
  };
}

export function addNewBackupClient(client) {
  return {
    type: types.ADD_NEW_BACKUP_CLIENT,
    client
  };
}

export function configureBackupClient(client) {
  return {
    type: types.CONFIGURE_BACKUP_CLIENT,
    clientUUID: client.clientUUID
  };
}

export function updateBackupMachineStatus(client) {
  return {
    type: types.UPDATE_BACKUP_MACHINE_STATUS,
    client
  };
}

export function updateBackupMachinesStatus(clients) {
  return {
    type: types.UPDATE_BACKUP_MACHINES_STATUS,
    clients: clients.onlineClients
  };
}

export function updateClientInfo(client) {
  return {
    type: types.UPDATE_CLIENT_INFO,
    client
  };
}

export function downloadClientSetupStart(client, origin) {
  return {
    type: types.DOWNLOAD_CLIENT_SETUP_START,
    client,
    origin
  };
}

export function downloadClientSetupComplete() {
  return {
    type: types.DOWNLOAD_CLIENT_SETUP_COMPLETE
  };
}

export function removeClientFromList(client) {
  return {
    type: types.REMOVE_CLIENT_FROM_LIST,
    clientUUID: client.clientUUID
  };
}

export function updateRestoreProgress(client) {
  return {
    type: types.UPDATE_RESTORE_PROGRESS,
    client
  };
}

export function restoreSetCompletion(client) {
  return {
    type: types.RESTORE_SET_COMPLETION,
    client
  };
}

export function restoreSetFailure(client) {
  return {
    type: types.RESTORE_SET_FAILURE,
    client
  };
}

export function removeRestoreState(client) {
  return {
    type: types.REMOVE_RESTORE_STATE,
    clientUUID: client.clientUUID
  };
}

export function initiateStopRestore(clientUUID) {
  return {
    type: types.INITIATE_STOP_RESTORE,
    clientUUID
  };
}

export function stopRestore(client) {
  return {
    type: types.STOP_RESTORE,
    client
  };
}

export function updateImageRestoreProgress(client) {
  return {
    type: types.UPDATE_IMAGE_RESTORE_PROGRESS,
    client
  };
}

export function removeBackupTempStatus(client) {
  return {
    type: types.REMOVE_BACKUP_TEMP_STATUS,
    clientUUID: client.clientUUID
  };
}

export function dashboardAPIDown(data) {
  return {
    type: types.DASHBOARD_API_DOWN,
    data
  };
}

export function hideDashboardNotify() {
  return {
    type: types.HIDE_DASHBOARD_NOTIFY
  };
}

export function fetchClientStatusStart(clientUUID, select) {
  return {
    type: types.FETCH_CLIENT_STATUS_START,
    clientUUID,
    select
  };
}

export function fetchClientStatusSuccess(data, select) {
  return {
    type: types.FETCH_CLIENT_STATUS_SUCCESS,
    data,
    select
  };
}

export function fetchClientVersionInfoStart() {
  return {
    type: types.FETCH_CLIENT_VERSION_INFO_START
  };
}

export function fetchClientVersionInfoSuccess(data) {
  return {
    type: types.FETCH_CLIENT_VERSION_INFO_SUCCESS,
    data
  };
}

export function fetchClientVersionInfoFailure(data) {
  return {
    type: types.FETCH_CLIENT_VERSION_INFO_FAILURE,
    data
  };
}

export function fetchDeploymentTokenStart() {
  return {
    type: types.FETCH_DEPLOYMENT_TOKEN_START
  };
}

export function fetchDeploymentTokenSuccess(token) {
  return {
    type: types.FETCH_DEPLOYMENT_TOKEN_SUCCESS,
    token
  };
}

export function downloadClientMSIStart() {
  return {
    type: types.DOWNLOAD_CLIENT_MSI_START
  };
}

export function downloadClientMSIComplete() {
  return {
    type: types.DOWNLOAD_CLIENT_MSI_COMPLETE
  };
}

export function fetchGroupsStart() {
  return {
    type: types.FETCH_GROUPS_START
  };
}

export function fetchGroupsSuccess(data) {
  return {
    type: types.FETCH_GROUPS_SUCCESS,
    data
  };
}

export function fetchGroupsFailure() {
  return {
    type: types.FETCH_GROUPS_FAILURE
  };
}

export function addClientsToGroupStart(data) {
  return {
    type: types.ADD_CLIENTS_TO_GROUP_START,
    data
  };
}

export function addClientsToGroupSuccess(data) {
  return {
    type: types.ADD_CLIENTS_TO_GROUP_SUCCESS,
    data
  };
}

export function addClientsToGroupFailure(data) {
  return {
    type: types.ADD_CLIENTS_TO_GROUP_FAILURE,
    data
  };
}

export function deleteDashboardGroupStart(data) {
  return {
    type: types.DELETE_DASHBOARD_GROUP_START,
    data
  };
}

export function deleteDashboardGroupSuccess(data) {
  return {
    type: types.DELETE_DASHBOARD_GROUP_SUCCESS,
    data
  };
}

export function deleteDashboardGroupFailure(data) {
  return {
    type: types.DELETE_DASHBOARD_GROUP_FAILURE,
    data
  };
}

export function renameDashboardGroupNameStart(data) {
  return {
    type: types.RENAME_DASHBOARD_GROUP_NAME_START,
    data
  };
}

export function renameDashboardGroupNameSuccess(data) {
  return {
    type: types.RENAME_DASHBOARD_GROUP_NAME_SUCCESS,
    data
  };
}

export function renameDashboardGroupNameFailure(data) {
  return {
    type: types.RENAME_DASHBOARD_GROUP_NAME_FAILURE,
    data
  };
}

export function createNewGroupDashboardStart(data) {
  return {
    type: types.CREATE_NEW_GROUP_DASHBOARD_START,
    data
  };
}

export function createNewGroupDashboardSuccess(data) {
  return {
    type: types.CREATE_NEW_GROUP_DASHBOARD_SUCCESS,
    data
  };
}

export function createNewGroupDashboardFailure(data) {
  return {
    type: types.CREATE_NEW_GROUP_DASHBOARD_FAILURE,
    data
  };
}

export function removeClientsFromGroupStart(data) {
  return {
    type: types.REMOVE_CLIENTS_FROM_GROUP_START,
    data
  };
}

export function removeClientsFromGroupSuccess(data) {
  return {
    type: types.REMOVE_CLIENTS_FROM_GROUP_SUCCESS,
    data
  };
}

export function fetchClientServerIPAddressStart(client) {
  return {
    type: types.FETCH_CLIENT_SERVERIPADDRESS_START,
    client
  };
}

export function fetchClientServerIPAddressResponse(client, ipAddress) {
  return {
    type: types.FETCH_CLIENT_SERVERIPADDRESS_RESPONSE,
    client,
    ipAddress
  };
}

export function createVirtualizationAccountStart(data) {
  return {
    type: types.CREATE_VIRTUALIZATION_ACCOUNT_START,
    data
  };
}

export function initiateVirtualizationStart(data, redirect, msg) {
  return {
    type: types.INITIATE_VIRTUALIZATION_START,
    data,
    redirect,
    msg
  };
}

export function initiateVirtualizationSuccess(data) {
  return {
    type: types.INITIATE_VIRTUALIZATION_SUCCESS,
    data
  };
}

export function controlVMFromDashboardStart(data, msg) {
  return {
    type: types.CONTROL_VM_FROM_DASHBOARD_START,
    data,
    msg
  };
}

export function controlVMFromDashboardSuccess(data) {
  return {
    type: types.CONTROL_VM_FROM_DASHBOARD_SUCCESS,
    data
  };
}

export function controlVMFromDashboardFailure(data) {
  return {
    type: types.CONTROL_VM_FROM_DASHBOARD_FAILURE,
    data
  };
}
